import React from "react";
import InputTextField from "./InputTextField";
import SearchFieldResult from "./SearchFieldResult";

export default function SearchField() {
  return (
    <div className="vp-search">
      <InputTextField />
      <SearchFieldResult />
    </div>
  );
}
